<template>
  <div class="upload-box">
    <div class="avatar-box" :style="avatarBoxStyle">
      <input type="file" :disabled="disabled" class="input-file" :style="commonStyle" :name="name" :ref="`avatarInput${name}`" @input="changeImage($event)" :accept="accept" />
      <!-- <img v-if="value" :src="value" alt :style="commonStyle" /> -->
      <el-image v-if="value" :style="commonStyle" :src="value" :preview-src-list="[value]"></el-image>
      <img v-else-if="defaultImg != '' && value == ''" :src="defaultImg" alt :style="commonStyle" />
      <div class="add-box" v-else :style="commonStyle">
        <i v-if="isLoading" class="el-icon-loading"></i>
        <div class="add-plus" v-if="!isLoading">
          <i class="el-icon-plus" :style="{ fontSize: iconSize + 'px' }"></i>
          <p>{{ defaultTipsTxt }}</p>
        </div>
      </div>
      <div class="cover-box" :class="zIndex ? 'zIndex' : ''" v-if="isShowCover || defaultImg" :style="coverStyle">
        <el-image v-if="value" :style="commonStyle" :src="value" :preview-src-list="[value]" @click.stop="handleOpenReview"></el-image>
        <div @click.stop="handleInput" v-if="!disabled" class="cover-plus">更换图片</div>
        <img v-if="allowDelete && !disabled" class="el-icon-close close" @click.stop="handleRemove" src="@/assets/images/icons/btn_del.png" alt="" />
      </div>
    </div>
    <div v-if="tip" class="tip">
      <p v-html="tip"></p>
      <el-popover placement="bottom" title="图片范例" width="400" trigger="click">
        <img :src="standardImgUrl" alt />
        <span v-if="standardImgUrl != ''" slot="reference" class="pic-example-btn">图片范例>></span>
      </el-popover>
    </div>
    <el-dialog title="裁剪图片" :visible.sync="visible" width="750px" :append-to-body="true">
      <div class="cropper-box">
        <vue-cropper ref="cropper" :guides="true" :view-mode="0" drag-mode="move" :aspectRatio="autoCropWidth / autoCropHeight" :auto-crop-area="0.7" :min-container-width="250" :min-container-height="180" :background="true" :rotatable="true" :src="cropedImg" alt="Source Image" :img-style="{ width: '400px', height: '300px' }" :cropmove="changeCrop"></vue-cropper>
        <div class="clearfix icon-box">
          <i @click="$refs.cropper.relativeZoom(0.1)" class="el-icon-circle-plus-outline icon-plus icon f-l"></i>
          <i @click="$refs.cropper.relativeZoom(-0.1)" class="el-icon-remove-outline icon-outline icon f-l"></i>
          <i @click="$refs.cropper.rotate(-90)" class="el-icon-refresh-left icon f-l"></i>
        </div>
      </div>
      <span slot="footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="handleCropper">确 定</el-button>
      </span>
    </el-dialog>
    <!-- <el-dialog title="预览图片" :visible.sync="picVisible">
      <img :src="avatar" width="100%" alt="" />
    </el-dialog> -->
  </div>
</template>
<script>
  // import service from "@/services/service";
  // import commonService from "@/commonService/index";

  import VueCropper from "vue-cropperjs";
  import "cropperjs/dist/cropper.css";
  export default {
    name: "upload",
    components: {
      VueCropper,
    },
    inject: {
      elForm: {
        default: "",
      },
      elFormItem: {
        default: "",
      },
    },
    data() {
      return {
        expVisible: false,
        avatar: "",
        isLoading: false,
        cropedImg: "",
        visible: false,
        picVisible: false,
        zIndex: false,
      };
    },
    component: {
      VueCropper,
    },
    computed: {
      commonStyle() {
        return {
          width: this.imgWidth,
          height: this.imgHeight,
          borderRadius: `${this.round ? "50%" : "4px"}`,
        };
      },
      coverStyle() {
        return {
          ...this.commonStyle,
          alignItems: "flex-end",
        };
      },
      avatarBoxStyle() {
        return {
          ...this.commonStyle,
          borderWidth: "1px",
          borderColor: this.value || this.defaultImg ? "#efefef" : "#999",
          borderStyle: this.value || this.defaultImg ? "solid" : "dashed",
        };
      },
      isShowCover() {
        return this.value;
      },
    },
    props: {
      value: String,
      defaultImg: {
        type: String,
        default: "",
      },
      allowDelete: {
        type: Boolean,
        default: true,
      },
      accept: {
        type: String,
        default: "image/gif,image/jpeg,image/jpg,image/png",
      },
      standardImgUrl: {
        type: [String, Number],
        default: "",
      },
      imgUrl: {
        type: [String, Number],
        default: "",
      },
      imgWidth: {
        type: [String, Number],
        default: "",
      },
      imgHeight: {
        type: [String, Number],
        default: "",
      },
      tip: {
        type: [String, Number],
        default: "",
      },
      name: {
        type: [String, Number],
        default: "",
      },
      round: {
        type: Boolean,
        default: false,
      },
      autoCropHeight: {
        type: [String, Number],
        default: 100,
      },
      autoCropWidth: {
        type: [String, Number],
        default: 100,
      },
      fixedNumber: {
        type: [Array],
        default: () => {
          return ["16:9"];
        },
      },
      maxSize: {
        type: Number,
        default: 8,
      },
      isCropper: {
        type: Boolean,
        default: false,
      },
      defaultTipsTxt: {
        type: String,
        default: "添加图片",
      },
      validateEvent: {
        type: Boolean,
        default: true,
      },
      iconSize: {
        type: Number,
        default: 26,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      acceptImgWidth: {
        type: Number,
        default: 0,
      },
      acceptImgHeight: {
        type: Number,
        default: 0,
      },
    },
    watch: {
      value(val) {
        this.avatar = val;
        this.$emit("change");
        if (!val) {
          this.cropedImg = "";
        }
        if (this.validateEvent && this.elFormItem) {
          this.elFormItem.validate("change");
        }
        this.clearValue();
      },
      visible(val) {
        if (!val) {
          this.clearValue();
        }
      },
    },
    methods: {
      changeCrop(obj) {
        console.log(obj);
      },
      handleInput() {
        console.log(this.name);
        this.$refs[`avatarInput${this.name}`].click();
      },
      //clear input filie value
      clearValue() {
        this.$refs[`avatarInput${this.name}`].value = "";
      },
      async changeImage(e) {
        let file = e.target.files[0];
        console.log("changeImage", file);
        if (file) {
          const isLt8M = file.size / 1024 / 1024 < this.maxSize;
          if (!this.accept.replace(/\s/g, "").split(",").includes(file.type)) {
            this.clearValue();
            this.$message.warning("请选择正确的图片格式");
            return;
          }
          if (!file.type.includes("image/")) {
            this.clearValue();
            this.$message.warning("请选择图片文件");
            return;
          }
          if (!isLt8M) {
            this.clearValue();
            this.$message.error(`上传的图片大小不能超过 ${this.maxSize}MB!`);
            return;
          }
          if (this.acceptImgWidth || this.acceptImgHeight) {
            let imgInfo = await new Promise((resolve, reject) => {
              const img = new Image();
              img.src = URL.createObjectURL(file);
              img.onload = function () {
                console.log(`Width: ${img.width}, Height: ${img.height}`);
                URL.revokeObjectURL(img.src); // 释放URL对象
                resolve({
                  width: img.width,
                  height: img.height,
                });
              };
            });
            if (imgInfo) {
              if (imgInfo.height != this.acceptImgHeight) {
                this.$message.error(`当前图片高度为${imgInfo.height},要求高度为${this.acceptImgHeight}`);
                return;
              }
              if (imgInfo.width != this.acceptImgWidth) {
                this.$message.error(`当前图片宽度为${imgInfo.width},要求宽度为${this.acceptImgWidth}`);
                return;
              }
            }
          }

          // 文件对象
          if (this.isCropper) {
            this.visible = true;
            if (typeof FileReader === "function") {
              const reader = new FileReader();
              reader.onload = (event) => {
                this.cropedImg = event.target.result;
                this.$refs.cropper.replace(event.target.result);
              };
              reader.readAsDataURL(file);
            } else {
              this.handleUpload(file);
            }
          } else {
            this.handleUpload(file);
          }
        }
      },

      handleUpload(file) {
        this.isLoading = true;
        let formData = new FormData();
        formData.append("file", file);
        this.$service.commonService.uploadImg(formData).then((res) => {
          this.isLoading = false;
          if (res.code == 200 && res.data) {
            let data = res.data;
            this.avatar = data.url;
            this.$emit("input", data.url);
            this.$emit("upload-success", data, this.name);
          }
        });
      },
      handleCropper() {
        this.visible = false;
        let data = this.$refs.cropper.getCroppedCanvas().toDataURL("image/jpeg", 0.7);
        let blob = this.dataURLtoBlob(data);
        this.handleUpload(blob);
      },
      //base64 to blob
      dataURLtoBlob(dataurl) {
        var arr = dataurl.split(","),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], { type: mime });
      },
      handleRemove() {
        this.clearValue();
        this.$emit("input", "");
        this.$emit("on-remove", this.name);
      },
      preview() {
        this.picVisible = true;
      },
      handleOpenReview() {
        this.zIndex = true;
        let maskList = document.querySelectorAll(".el-image-viewer__mask");
        let domImageCloseList = document.querySelectorAll(".el-image-viewer__close");
        if (!domImageCloseList.length > 0 && !maskList.length > 0) {
          return;
        }
        [].forEach.call(domImageCloseList, (item) => {
          item.addEventListener("click", () => {
            setTimeout(() => {
              this.zIndex = false;
            }, 500);
          });
        });

        [].forEach.call(maskList, (item) => {
          item.addEventListener("click", () => {
            [].forEach.call(domImageCloseList, (it) => {
              it.click();
            });
          });
        });
      },
    },
  };
</script>
<style lang="less" scoped>
  @import "~@/styles/variable.less";
  .upload-box {
    // display: inline-block;
    .avatar-box {
      position: relative;
      width: 100%;
      border: 1px dashed #999;
      background-color: #f6f8fb;
      cursor: pointer;
      font-size: 20px;
      text-align: center;
      .input-file {
        position: absolute;
        z-index: 2;
        top: 0;
        left: 0;
        width: 100%;
        cursor: pointer;
        opacity: 0;
      }
      .text {
        padding-top: 10px;
        color: lightblue;
      }
    }
    .tip {
      margin-top: 5px;
      color: #999;
      line-height: 18px;
      p {
        font-size: 12px;
      }
    }
    .add-box {
      display: flex;
      align-items: center;
      justify-content: center;
      .add-plus {
        color: #666;
        cursor: pointer;
        font-size: 12px;
        line-height: 20px;
      }
      i {
        font-size: 25px;
      }
    }
  }
  .cover-box {
    position: absolute;
    z-index: 99;
    top: 0;
    display: flex;
    background-color: rgba(51, 51, 51, 0);
    &.zIndex {
      z-index: 1000;
    }
    .close {
      position: absolute;
      top: -7px;
      right: -7px;
    }
    .upload-text {
      color: #fff;
      font-size: 14px;
    }
    .cover-plus {
      // bottom: 0;
      position: absolute;
      display: flex;
      width: 100%;
      height: 25px;
      align-items: center;
      justify-content: center;
      background-color: rgba(0, 0, 0, 0.6);
      color: #fff;
      /* background-color: red; */
      font-size: 12px;
    }
  }
  .cropper-box {
    width: 700px;
    height: 300px;
    .icon-box {
      margin-top: 10px;
      margin-bottom: 20px;
      .icon {
        display: inline-block;
        margin-right: 10px;
        color: @primaryColor;
        cursor: pointer;
        font-size: 22px;
      }
    }
  }
  .pic-example-btn {
    color: @primaryColor;
    cursor: pointer;
  }
</style>
